interface AssetClassHeaderProps {
  title: string;
}

export function AssetClassHeader({ title }: AssetClassHeaderProps) {
  return (
    <div className="flex items-center gap-2">
      <h4 className="text-sm font-medium leading-none">{title}</h4>
    </div>
  );
}
